// extracted by mini-css-extract-plugin
export default {"integration-update-modal-content":"style_integration-update-modal-content__miy0F"};